/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { makeStyles } from '@material-ui/core/styles'
import { requestFirebaseNotificationPermission } from '../../firebaseInit'
import useUsersApi from '../../hooks/users/useUsersApi'
import ReactHowler from 'react-howler'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { getMessaging, onMessage } from 'firebase/messaging'
import cookies from '../../utils/cookies'
import { userTypes } from '../../utils/constants'
import useEventsStore from '../../stores/Events'
import useDebounce from '../../hooks/useDebounce'
import { BuildingsIcon } from '../../images/buildings'
import { EventsIcon } from '../../images/events'
import { ErrorsIcon } from '../../images/errors'
import { CommunicationsIcon } from '../../images/communications'
import { InvitationsIcon } from '../../images/invitations'
import { AuthorizedIcon } from '../../images/authorized'
import { UserEventsIcon } from '../../images/user-events'
import { NotificationsIcon } from '../../images/notifications'
import { ShoppingIcon } from '../../images/shopping'
import { ResidentsIcon } from '../../images/residents'
import { ServicesIcon } from '../../images/services'
import { ManualEntryIcon } from '../../images/manual-entry'
import { BlacklistedIcon } from '../../images/blacklisted'
import { ConstructionsIcon } from '../../images/constructions'
import { AmenitiesIcon } from '../../images/amenities'
import { pathMapping, paths } from '../../utils/paths'
import { useIsSecurityUser } from '../../hooks/useIsSecurityUser'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { EventHistoryIcon } from '../../images/event-history'
import styleClasses from '../../components/common/common.module.scss'
import useNotificationsApi from '../../hooks/notifications/useNotificationsApi'
import { useNotification } from '../../hooks/notifications/notificationContext'
import { SecurityIcon } from '../../images/security'
const messaging = getMessaging()

export default function ListItems({ drawerOpen }) {
  const getLoggedUser = () => {
    try {
      const user = cookies.get('user')
      return JSON.parse(user)
    } catch (e) {
      return null
    }
  }
  const loggedUser = getLoggedUser()
  const isSecurityUser = useIsSecurityUser()
  const [open, setOpen] = useState(false)
  const [sound, setSound] = useState(false)
  const [formatedDataPush, setFormatedDataPush] = useState({})
  const classes = useStyles()
  const history = useHistory()
  const [{ usersState }, { createUserDeviceToken }] = useUsersApi()
  const eventsStore = useEventsStore((state) => state)
  const {
    state: { notificationsToOpenState },
    methods: { getNotificationsToOpen, receiveNotification },
  } = useNotification()

  useEffect(() => {
    getNotificationsToOpen()
  }, [])

  const location = useLocation()
  const { pathOverride } = location.state || {}

  // get events every 60 seconds at max also we just get the new events
  const getEvents = useDebounce(() => {
    eventsStore.getEvents()
  }, 60000)

  onMessage(messaging, (payload) => {
    const formatedData = `${payload?.data?.data}`
    const parsedData = JSON.parse(formatedData || '{}')

    setFormatedDataPush(parsedData)
    if (parsedData?.type === 'EVENT') {
      if (parsedData?.event?.type === 'SOS') {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: '/spotter.png',
        })
        setOpen(true)
        setSound(true)
      } else {
        if (location.pathname.includes('eventos')) {
          if (parsedData?.event) {
            // TODO this works but we need to improve the data we send from the backend also we should considere filtering from the events page
            // eventsStore.addEventFromNotification(parsedData?.event)
            getEvents()
          }
        }
      }
    } else if (parsedData?.type === 'NOTIFICATION') {
      const notificationToAdd = {
        ...parsedData.notification,
        user: parsedData.user,
        serviceTypeForeign: parsedData.serviceType,
      }
      if (
        parsedData.serviceType.shopping &&
        location.pathname.includes('compras')
      ) {
        receiveNotification(notificationToAdd)
      }
      if (
        !parsedData.serviceType.shopping &&
        location.pathname.includes('notificaciones')
      ) {
        receiveNotification(notificationToAdd)
      }
      getNotificationsToOpen()
    }
    setTimeout(() => {
      setSound(false)
    }, 10000)
  })

  useEffect(() => {
    const getFirebaseToken = () => {
      requestFirebaseNotificationPermission(createUserDeviceToken)
    }
    getFirebaseToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => {
    setOpen(false)
    location.reload()
  }

  const listItems = [
    {
      label: 'Registro manual',
      path: paths.MANUAL_ACCESS,
      icon: (
        <ManualEntryIcon
          color={
            pathMapping[paths.MANUAL_ACCESS].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.security, userTypes.securityAdmin, userTypes.admin],
    },
    {
      label: 'Porteros',
      path: paths.DOORBELLS,
      icon: (
        <ManualEntryIcon
          color={
            pathMapping[paths.MANUAL_ACCESS].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.admin, userTypes.operator],
    },
    {
      label: 'Historial',
      path: paths.EVENTS,
      icon: (
        <EventHistoryIcon
          color={
            pathMapping[paths.EVENTS].some((path) =>
              new RegExp(`^${path}$`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.operator,
        userTypes.securityAdmin,
        userTypes.gestor,
      ],
    },
    {
      label: 'Eventos',
      path: paths.USER_EVENTS,
      icon: (
        <UserEventsIcon
          color={
            pathMapping[paths.USER_EVENTS].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.operator,
        userTypes.gestor,
      ],
    },
    {
      label: 'Historial',
      path: paths.BUILDING_EVENTS,
      icon: (
        <EventHistoryIcon
          color={
            pathMapping[paths.BUILDING_EVENTS].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.security],
    },
    {
      label: 'Eventos',
      path: paths.USER_EVENTS_FOR_BUILDING,
      icon: (
        <EventsIcon
          color={
            pathMapping[paths.USER_EVENTS_FOR_BUILDING].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.security, userTypes.securityAdmin],
    },
    {
      label: 'Arribo de Servicios',
      path: paths.NOTIFICATIONS,
      icon: (
        <div
          className={
            notificationsToOpenState?.notifications?.data?.find(
              (notification) => !notification.serviceTypeForeign.shopping
            ) && styleClasses.shoppingIcon
          }
        >
          <NotificationsIcon
            color={
              pathMapping[paths.NOTIFICATIONS].some((path) =>
                new RegExp(`^${path}`).test(
                  pathOverride ?? history.location.pathname
                )
              ) && '#3068F9'
            }
          />
        </div>
      ),
      allowed: [
        userTypes.security,
        userTypes.securityAdmin,
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.operator,
        userTypes.gestor,
      ],
    },
    {
      label: 'Cadetería',
      path: paths.SHOPPING,
      icon: (
        <div
          className={
            notificationsToOpenState?.notifications?.data?.find(
              (notification) => notification.serviceTypeForeign.shopping
            ) && styleClasses.shoppingIcon
          }
        >
          <ShoppingIcon
            color={
              pathMapping[paths.SHOPPING].some((path) =>
                new RegExp(`^${path}`).test(
                  pathOverride ?? history.location.pathname
                )
              ) && '#3068F9'
            }
          />
        </div>
      ),
      allowed: [
        userTypes.security,
        userTypes.securityAdmin,
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.operator,
        userTypes.gestor,
      ],
    },
    {
      label: 'Comunicaciones',
      path: paths.COMMUNICATIONS,
      icon: (
        <CommunicationsIcon
          color={
            pathMapping[paths.COMMUNICATIONS].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.operator,
        userTypes.security,
        userTypes.securityAdmin,
      ],
    },
    {
      label: 'Edificios/Barrios',
      path: paths.BUILDINGS,
      icon: (
        <BuildingsIcon
          color={
            pathMapping[paths.BUILDINGS].some((path) =>
              new RegExp(`^${path}`).test(
                pathOverride ?? history.location.pathname
              )
            ) && '#3068F9'
          }
        />
      ),
      allowed: [
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.gestor,
        userTypes.operator,
      ],
    },
    {
      label: 'Amenities',
      devOnly: true,
      path: paths.AMENITIES,
      icon: (
        <AmenitiesIcon
          color={
            pathMapping[paths.AMENITIES].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.admin, userTypes.buildingAdmin],
    },
    {
      label: 'Reservas',
      devOnly: true,
      path: paths.RESERVATIONS,
      // Re-use the AmenitiesIcon — the menu reads as a sub-section of amenities
      // so the visual contract stays consistent.
      icon: (
        <AmenitiesIcon
          color={
            pathMapping[paths.RESERVATIONS].some((path) =>
              new RegExp(`^${path}$`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.admin, userTypes.buildingAdmin],
    },
    {
      label: 'Reporte de reservas',
      devOnly: true,
      path: paths.RESERVATIONS_REPORT,
      icon: (
        <AmenitiesIcon
          color={
            pathMapping[paths.RESERVATIONS_REPORT].some((path) =>
              new RegExp(`^${path}$`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.admin, userTypes.buildingAdmin],
    },
    {
      label: 'Reportes mensuales',
      devOnly: true,
      path: paths.MONTHLY_REPORTS,
      icon: (
        <AmenitiesIcon
          color={
            pathMapping[paths.MONTHLY_REPORTS].some((path) =>
              new RegExp(`^${path}$`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.admin, userTypes.buildingAdmin],
    },
    {
      label: 'Invitaciones',
      path: paths.INVITATIONS,
      icon: (
        <InvitationsIcon
          color={
            pathMapping[paths.INVITATIONS].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.admin, userTypes.buildingAdmin, userTypes.gestor],
    },
    {
      label: isSecurityUser ? 'Residentes' : 'Usuarios',
      path: paths.USERS,
      icon: (
        <ResidentsIcon
          color={
            pathMapping[paths.USERS].some((path) =>
              new RegExp(`^${path}`).test(
                pathOverride ?? history.location.pathname
              )
            ) && '#3068F9'
          }
        />
      ),
      allowed: [
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.operator,
        userTypes.security,
        userTypes.securityAdmin,
        userTypes.gestor,
      ],
    },
    {
      label: 'Visitas',
      path: paths.GUESTS,
      icon: (
        <AuthorizedIcon
          color={
            pathMapping[paths.GUESTS].some((path) =>
              new RegExp(`^${path}`).test(
                pathOverride ?? history.location.pathname
              )
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.security, userTypes.securityAdmin],
    },
    {
      label: 'Seguridad',
      path: paths.SECURITY_USERS,
      icon: (
        <SecurityIcon
          color={
            pathMapping[paths.SECURITY_USERS].some((path) =>
              new RegExp(`^${path}`).test(
                pathOverride ?? history.location.pathname
              )
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.security, userTypes.securityAdmin],
    },
    {
      label: 'Visitas',
      path: paths.GUESTS,
      icon: (
        <AuthorizedIcon
          color={
            pathMapping[paths.GUESTS].some((path) =>
              new RegExp(`^${path}`).test(
                pathOverride ?? history.location.pathname
              )
            ) && '#3068F9'
          }
        />
      ),
      allowed: [
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.operator,
        userTypes.gestor,
      ],
    },
    {
      label: 'Servicios',
      path: paths.SERVICES,
      icon: (
        <ServicesIcon
          color={
            pathMapping[paths.SERVICES].some((path) =>
              new RegExp(`^${path}`).test(
                pathOverride ?? history.location.pathname
              )
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.security, userTypes.securityAdmin, userTypes.admin],
    },
    {
      label: 'Restringidos',
      path: paths.BLACKLISTED,
      icon: (
        <BlacklistedIcon
          color={
            pathMapping[paths.BLACKLISTED].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [
        userTypes.security,
        userTypes.securityAdmin,
        userTypes.admin,
        userTypes.buildingAdmin,
        userTypes.operator,
        userTypes.gestor,
      ],
    },
    {
      label: 'Obras',
      path: paths.CONSTRUCTIONS,
      icon: (
        <ConstructionsIcon
          color={
            pathMapping[paths.CONSTRUCTIONS].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [
        userTypes.security,
        userTypes.admin,
        userTypes.securityAdmin,
        userTypes.gestor,
      ],
    },
    {
      label: 'Errores',
      path: paths.ERRORS,
      icon: (
        <ErrorsIcon
          color={
            pathMapping[paths.ERRORS].some((path) =>
              new RegExp(`^${path}`).test(history.location.pathname)
            ) && '#3068F9'
          }
        />
      ),
      allowed: [userTypes.admin, userTypes.buildingAdmin, userTypes.gestor],
    },
  ]

  const isAllowed = (item, userType) => {
    // Amenities and reservations release separately: local development only for now.
    if (item.devOnly && process.env.NODE_ENV !== 'development') return false
    return item.allowed.includes(userType)
  }

  const renderListItems = () => {
    return (
      <>
        {listItems
          .filter((listItem) => isAllowed(listItem, loggedUser?.type))
          .map((listItem) => (
            <ListItem
              className={clsx(
                classes.listItem,
                pathMapping[listItem.path].some((path) => {
                  const regex = new RegExp(
                    `^${path.replace(/:[^\s/]+/g, '[^/]+')}$`
                  )
                  return regex.test(pathOverride ?? history.location.pathname)
                }) && classes.listItemSelected
              )}
              button
              onClick={() => history.push(listItem.path)}
            >
              <ListItemIcon
                className={classes.listItemIcon}
                onClick={() => history.push(listItem.path)}
              >
                {listItem.icon}
              </ListItemIcon>
              {drawerOpen && <ListItemText primary={listItem.label} />}
            </ListItem>
          ))}
      </>
    )
  }

  return (
    <>
      {renderListItems()}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{'Evento SOS'}</DialogTitle>
        <DialogContent style={{ fontSize: '24px' }}>
          <DialogContentText
            id="alert-dialog-description"
            style={{ marginTop: '25px' }}
          >
            {`Usuario: ${formatedDataPush?.user?.name} ${formatedDataPush?.user?.surname}`}
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            {`Edificio: ${
              formatedDataPush?.user?.apartments &&
              formatedDataPush?.user?.apartments[0] &&
              formatedDataPush?.user?.apartments[0]?.building?.name
            }`}
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            {`Apartamento: ${
              formatedDataPush?.user?.apartments &&
              formatedDataPush?.user?.apartments[0] &&
              formatedDataPush?.user?.apartments[0]?.name
            }`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => location.reload()}>
            Recibido
          </Button>
        </DialogActions>
      </Dialog>
      <ReactHowler src="/pb524admw-x.mp3" playing={sound} preload loop />
    </>
  )
}

const useStyles = makeStyles({
  listItem: {
    paddingLeft: '26px',
    height: '52px',
    '& .MuiListItem-root.Mui-selected': {
      backgroundColor: '#EDF2FF',
    },
    '&:hover': {
      backgroundColor: '#d6e0fc',
    },
  },
  listItemSelected: {
    '& .MuiTypography-root': {
      color: '#3068F9',
    },
    backgroundColor: 'white',
  },
  listItemIcon: {
    minWidth: '34px',
  },
})
